import { Component, DestroyRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { Router } from '@angular/router';
import { SnackService } from '../../service/snack.service';
import { statusType } from '../../interfaces/enumStatusType';
import { distinctUntilChanged, merge } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DisclaimerTypes } from '../../interfaces/disclaimertypes';

const LOGIN_FAILED_ERRORS = [
    'invalidLogin',
    'confirmMail',
];

@Component({
    selector: 'app-login-form',
    standalone: false,

    templateUrl: './login-form.component.html',
    styleUrl: './login-form.component.scss'
})
export class LoginFormComponent {
    hidespinner: boolean = true;
    loginForm: FormGroup;
    disclaimerType: DisclaimerTypes = DisclaimerTypes.TERMS_CONDITIONS;
    disclaimerTypeFooter: DisclaimerTypes = DisclaimerTypes.PAGE_FOOTER;
    constructor(
        private authService: AuthandregistryService,
        private _fb: FormBuilder,
        private router: Router,
        private destroyRef: DestroyRef,
        private snack: SnackService
    ) {
        this.loginForm = this._fb.group({
            email: new FormControl('', Validators.required),
            password: new FormControl('', Validators.required),
        });
        authService.doAutoLogin();
        // setTimeout(() => {
        //   snack.snackHeadline.next('Welcome to the Login');
        //   snack.snackText.next('Please login to access your account');
        //   snack.type.next(statusType.Warning);
        //   snack.showSnack.next(true);
        // }, 2000);
    }

    async onSubmit() {
        if (
            (
                this.loginForm.invalid &&
                !this.controlsHaveErrors(['confirmMail'])
            ) ||
            typeof this.loginForm.value.email !== 'string' ||
            typeof this.loginForm.value.password !== 'string'
        ) {
            return;
        }

        this.hidespinner = false;
        localStorage.setItem('idea_loginemail', this.loginForm.value.email)

        const isSuccess = await this.authService.doLogin(this.loginForm.value.email, this.loginForm.value.password);

        this.handleLoginFailedFormErrors(isSuccess);

        this.hidespinner = true;
    }

    gotopwforgotten() {
        if (this.loginForm.value.email != '' && this.loginForm.value.email) sessionStorage.setItem('email', this.loginForm.value.email);
        this.router.navigate(['/login/password-forgotten']);
    }

    private handleLoginFailedFormErrors(
        isLoginSuccess: boolean | number
    ): void {
        if (
            typeof isLoginSuccess === 'boolean' &&
            isLoginSuccess === true
        ) {
            return;
        }

        const emailControl = this.loginForm.controls['email'];
        const passwordControl = this.loginForm.controls['password'];

        if (
            isLoginSuccess === 400 ||
            isLoginSuccess === 404
        ) {
            emailControl.setErrors({ invalidLogin: true });
            passwordControl.setErrors({ invalidLogin: true });
        } else if (isLoginSuccess === 403) {
            emailControl.setErrors({ confirmMail: true });
            passwordControl.setErrors({ confirmMail: true });
        }

        merge(
            emailControl.valueChanges.pipe(distinctUntilChanged()),
            passwordControl.valueChanges.pipe(distinctUntilChanged()),
        )
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: () => {
                    if (this.controlsHaveErrors()) {
                        emailControl.setErrors(null);
                        passwordControl.setErrors(null);
                    }
                },
            });
    }

    private controlsHaveErrors(errors: string[] = LOGIN_FAILED_ERRORS): boolean {
        const emailControl = this.loginForm.controls['email'];
        const passwordControl = this.loginForm.controls['password'];

        return errors.some(
            (error) =>
                emailControl.hasError(error) ||
                passwordControl.hasError(error)
        )
    }
}
